export class Configuration {
    static url: string = '';
    static apiGen: string = '';
    static serviceRechner: string = 'retirement';
    static apiName: string = 'rentencheck';
    static urlWithServiceRechner: string = Configuration.url + Configuration.serviceRechner;
    static urlWithApiGen: string = Configuration.url + Configuration.apiGen;
}



// WEBPACK FOOTER //
// ./src/config/environment.ts